// src/api/gmail.js
import api from './api';

export const onboardingAPI = {
    // Process and chunk all emails
    chunkAllEmails: async () => {
        try {
            const response = await api.post('/onboarding/chunk-all-emails');
            return response.data;
        } catch (error) {
            console.error('Error processing emails:', error);
            throw error;
        }
    },
    // Create companies from email analysis
    createCompaniesFromEmails: async () => {
        try {
            const response = await api.post('/onboarding/createUserCompanies');
            return response.data;
        } catch (error) {
            console.error('Error creating companies:', error);
            throw error;
        }
    },
    // update companies fields
    updateAllCompanyFields: async () => {
        try {
            const response = await api.post('/onboarding/updateAllCompanyFields');
            return response.data;
        } catch (error) {
            console.error('Error updating company fields:', error);
            throw error;
        }
    },
    // Process and create all key contacts
    initializeContacts: async () => {
        try {
            const response = await api.post('/onboarding/initialize-contacts');
            return response.data;
        } catch (error) {
            console.error('Error initialize key contacts :', error);
            throw error;
        }
    },
    // onboarding method
    finalizeOnboarding: async () => {
        try {
            const response = await api.post('/onboarding/finalize-onboarding');
            return response.data;
        } catch (error) {
            console.error('Error in finalize onboarding :', error);
            throw error;
        }
    }

};
